import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { Dialog, styled, Box as MuiBox } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    width: '100%',
    maxWidth: '37.5rem',
    padding: '1.5rem',
    gap: '2rem',
    flexGrow: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '1.5rem',
    },
  },
}));

export const Content = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1.5rem',
  flexGrow: 1,
  overflow: 'hidden',
  minHeight: 0,
}));

export const CloseBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[600],
  },
}));

export const Icon = styled('img')(() => ({
  width: '9.5rem',
  marginBottom: '1.5rem',
}));

export const BoxButton = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center'
}));

export const InfoBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.details.light,
  gap: '0.75rem',
  minWidth: '16.5rem',
  maxWidth: '28.75rem',
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
}));

export const InfoIconStyled = styled(InfoIcon)(({ theme }) => ({
  color: theme.palette.primary.dark,
}));